import { CandidateStatus } from 'generated-graphql/types';

export const candidateStatusOrder = {
  [CandidateStatus.ShortListed]: 1,
  [CandidateStatus.Rejected]: 2,
  [CandidateStatus.Progressing]: 3,
  [CandidateStatus.NotProgressing]: 4,
  [CandidateStatus.Review]: 5,
  [CandidateStatus.InterviewStage_1]: 6,
  [CandidateStatus.InterviewStage_2]: 7,
  [CandidateStatus.Offer]: 8
};
